// Reports script errors in visitors' browsers to the CST server, where they
// show on the Road Ready admin's System Maintenance page ("Visitor browser")
// and in the daily error email. Production only; at most 5 different errors
// per page view; the page address is sent without its ?query or #hash so
// tokens never leave the browser. Sent as text/plain (no CORS preflight).
const MAX_PER_PAGE = 5;

export function startErrorReporting(endpoint) {
  if (typeof window === 'undefined' || window.__cstErrorReporting) return;
  if (process.env.NODE_ENV !== 'production') return;
  window.__cstErrorReporting = true;
  const seen = new Set();

  const send = report => {
    const key = `${report.message}|${report.source}|${report.line}`;
    if (seen.size >= MAX_PER_PAGE || seen.has(key)) return;
    seen.add(key);
    const url = window.location.href.split(/[?#]/)[0];
    try {
      fetch(endpoint, {
        method: 'POST', keepalive: true, credentials: 'omit',
        headers: { 'Content-Type': 'text/plain' },
        body: JSON.stringify({ ...report, url }).slice(0, 8000),
      }).catch(() => {});
    } catch { /* never let reporting cause another error */ }
  };

  window.addEventListener('error', e => {
    // A failed <img>/<script> load fires an error event without a message.
    if (!e.message) return;
    send({
      kind: 'error', name: e.error && e.error.name, message: e.message,
      source: e.filename, line: e.lineno, col: e.colno,
      stack: e.error && e.error.stack ? String(e.error.stack).slice(0, 1500) : null,
    });
  });
  window.addEventListener('unhandledrejection', e => {
    const r = e.reason;
    send({
      kind: 'promise', name: r && r.name,
      message: (r && r.message) || String(r),
      stack: r && r.stack ? String(r.stack).slice(0, 1500) : null,
    });
  });
}
